import { dataLeggibile } from '../../shared/date.js';

/** Crea un elemento con classi, attributi e figli (testo o nodi). */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string | ((ev: Event) => void)> = {},
  ...children: Array<Node | string | null | undefined>
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (typeof value === 'function') node.addEventListener(key, (event) => {
      const button = key === 'click' && node instanceof HTMLButtonElement ? node : null;
      if (button?.disabled) return;
      const failed = (error: unknown): void => {
        console.error(error);
        window.dispatchEvent(new CustomEvent('memorie:action-error'));
      };
      try {
        const result: unknown = value(event);
        if (result instanceof Promise) {
          if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
          void result.catch(failed).finally(() => {
            if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
          });
        }
      } catch (error) { failed(error); }
    });
    else if (key === 'class') node.className = value;
    else node.setAttribute(key, value);
  }
  for (const child of children) {
    if (child === null || child === undefined) continue;
    node.append(typeof child === 'string' ? document.createTextNode(child) : child);
  }
  return node;
}

export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

/** Una data EDTF (o un timestamp del server) in parole: «12 giugno 1954», «anni Cinquanta»,
 *  «dal 1950». Le regole stanno in src/shared/date.ts, le stesse del server; se non la sappiamo
 *  leggere resta com'è. */
export function fmtDate(iso: string): string {
  return dataLeggibile(iso) ?? iso;
}

export function fmtTimer(s: number): string {
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${String(sec).padStart(2, '0')}`;
}

/** «oggi», «ieri», «3 giorni fa», poi la data. Le date del server sono UTC. */
export function quandoRelativo(iso: string): string {
  const t = Date.parse(iso.includes('T') ? iso : iso.replace(' ', 'T') + 'Z');
  if (Number.isNaN(t)) return '';
  const oggi = new Date(); oggi.setHours(0, 0, 0, 0);
  const giorno = new Date(t); giorno.setHours(0, 0, 0, 0);
  const diff = Math.round((oggi.getTime() - giorno.getTime()) / 86_400_000);
  if (diff <= 0) return 'oggi';
  if (diff === 1) return 'ieri';
  if (diff < 7) return `${diff} giorni fa`;
  return fmtDate(new Date(t).toISOString());
}
